import GuiContext from "config/context/guiContext";
import { useContext, useState } from "react";

/**
 * Šta se gubi skidanjem baze sa spiska — pitano pre nego što se skine.
 *
 * Skidanje ne dira lanac, ali baza koju posle toga niko nema u spisku se kroz
 * GUI više ne vidi. Nazad se dovodi jedino kroz Add New Database → import, a to
 * traži IME i PRIVATNI KLJUČ. Otud dva pitanja, i samo su dva jer je treće
 * („ko još drži ključ") nedostupno — čvor nema pretragu naloga po ključu.
 *
 *   keyValid   ume li pozivalac da je vrati
 *   holders    vidi li je još neki korisnik ovog GUI-ja
 *
 * Nijedno nije brana. Zajedno određuju šta se korisniku ponudi: kad je baza i
 * dokazano nepovratna i nevidljiva svima ostalima, brisanje ima smisla ponuditi
 * uz skidanje — inače nema.
 */
export const useAccessCheck = () => {
    const [checking, setChecking] = useState(false);
    const [result, setResult] = useState(null);
    const { selected: { selectedServer }, userData, URL } = useContext(GuiContext);

    const check = async (database, privateKey) => {
        setChecking(true);
        setResult(null);
        try {
            const res = await fetch(`${URL}/api/inerygui/access_check`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    guiname: userData?.guiname,
                    account_name: database,
                    server_url: selectedServer,
                    private_key: privateKey || undefined,
                }),
            });
            const body = await res.json();
            if (!body?.status) throw new Error(body?.message || "Check failed");
            setResult(body);
            return body;
        } catch (error) {
            // Neuspela provera se NE prećutkuje u „sve je u redu". Bez odgovora
            // se ne zna ni da li je baza povratna ni da li je još neko vidi, pa
            // se prijavljuje kao nepoznato i dijalog ostaje na opreznoj strani.
            const unknown = { status: false, unknown: true, error: String(error.message || error) };
            setResult(unknown);
            return unknown;
        } finally {
            setChecking(false);
        }
    };

    const reset = () => setResult(null);

    return { check, checking, result, reset };
};
